import { ActivatedRouteSnapshot, DetachedRouteHandle } from '@angular/router';
import { RouteReuseStrategy } from '@angular/router';
import { Injectable } from '@angular/core';

@Injectable()
export class CustomRouteReuseStrategy extends RouteReuseStrategy {
  public shouldDetach(route: ActivatedRouteSnapshot): boolean {
    return false;
  }
  public store(route: ActivatedRouteSnapshot, detachedTree: DetachedRouteHandle): void {}
  public shouldAttach(route: ActivatedRouteSnapshot): boolean {
    (<any>window).Intercom('update');
    return false;
  }
  public retrieve(route: ActivatedRouteSnapshot): DetachedRouteHandle {
    return null;
  }
  public shouldReuseRoute(future: ActivatedRouteSnapshot, curr: ActivatedRouteSnapshot): boolean {
    const name = future.component && (<any>future.component).name;
    /*
    Do as normal (future.routeConfig === curr.routeConfig) unless its one of these: && (name !== ... && name !== ......)
    */

    return future.routeConfig === curr.routeConfig; // && curr.component !== ConvertComponent;
    // return future.routeConfig === curr.routeConfig; // Default
  }
}
